import { render, staticRenderFns } from "./risk-file-manager-view.vue?vue&type=template&id=8be18fde&scoped=true&"
import script from "./risk-file-manager-view.vue?vue&type=script&lang=js&"
export * from "./risk-file-manager-view.vue?vue&type=script&lang=js&"
import style0 from "./risk-file-manager-view.vue?vue&type=style&index=0&id=8be18fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be18fde",
  null
  
)

export default component.exports